// Custom body container, Scroll handler and restorer

( function( $, window, document, undefined ) {

	let $scrollContainer = $('.js-main-scroll-container'),
			$sections = $scrollContainer.find('.js-section'),
			scrollPosition = $scrollContainer.scrollTop(),
			scrollSpyThreshold = 0.6;

	if ( !$('body').hasClass('home') ) {
		// Save scroll position before unload
		window.onbeforeunload = () => {
			localStorage.setItem( 'scrollPosition', $scrollContainer.scrollTop() );
			localStorage.setItem( 'scrollPage', window.location );
		};

		// Restore scroll position on load
		$(document).ready( () => {
			let scrollPosition = localStorage.getItem( 'scrollPosition' ),
					scrollPage = localStorage.getItem( 'scrollPage' );

			localStorage.removeItem( 'scrollPosition' );
			localStorage.removeItem( 'scrollPage' );

			if ( window.location == scrollPage && null !== scrollPosition ) {
				$scrollContainer.scrollTop( scrollPosition );
			}
		} );
	}

	function getSectionInDirection( direction ) {
		let _$section = null;

		$sections.each( ( index, section ) => {
			const $section = $(section);
			
			// Get the 1st section whose top edge is on screen
			if ( 
				null === _$section &&
				( $section.offset().top + $scrollContainer.scrollTop() ).toFixed(0) >= $scrollContainer.scrollTop() 
			) {

				if ( direction >= 0 ) {
					// Scrolling down - return that section
					_$section = $section;
				} else {
					// Scrolling up - return the section directly before that one
					_$section = $sections.eq( Math.max( index - 1, 0 ) );
				}

			}
		} );

		if ( null === _$section ) {
			_$section = $sections.last();
		}

		return _$section;
	}

	function scrollSpySections() {
		let _scrollPosition = $scrollContainer.scrollTop(),
				// Get scroll delta, > 0 down, < 0 up
				delta = _scrollPosition - scrollPosition,
				$section = getSectionInDirection( delta ),
				sectionName;

		if ( $section.length ) {
			sectionName = $section.attr('data-section-name') ? $section.attr('data-section-name') : $section.attr('id');

			sectionName = '#' + sectionName.replace(/ /g,"-");

			if ( location.hash !== sectionName && percentInViewport( $section ) >= scrollSpyThreshold ) {
				if(history.pushState) {
	        try {
	          history.replaceState(null, null, sectionName);
	        } catch (e) {
	          if(window.console) {
	            console.warn("Warning: Page must be hosted to manipulate the hash value.");
	          }
	        }
	      } else {
	        window.location.hash = sectionName;
	      }
			}

			scrollPosition = _scrollPosition;
		}
	}

	$scrollContainer.scroll( throttle( (event) => {
		scrollSpySections();
	}, 150 ) );
	
} )( jQuery, window, document );
